import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

export default class extends Controller {
  static values = {
    businessQueueId: Number,
    page: String  // "dashboard", "management", or "public"
  }

  connect() {
    this.subscription = consumer.subscriptions.create(
      {
        channel: "BusinessQueueChannel",
        business_queue_id: this.businessQueueIdValue
      },
      {
        received: (data) => {
          console.log('[BusinessQueueController] Received broadcast:', data)
          if (data.action === 'update') {
            this.handleEntryUpdate(data)
          } else if (data.action === 'remove') {
            this.handleEntryRemoval(data)
          } else if (data.action === 'queue_status_update') {
            this.updateQueueStatus(data)
          }
        }
      }
    )
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  handleEntryUpdate(data) {
    const entryElement = document.querySelector(`[data-queue-entry-id="${data.entry_id}"]`)
    const isTerminalStatus = ['completed', 'cancelled', 'no_show'].includes(data.status)
    // Use management partial HTML on the queue management page, dashboard partial elsewhere
    const entryHtml = this.pageValue === 'management' && data.management_html
      ? data.management_html
      : data.html

    if (entryElement) {
      if (isTerminalStatus) {
        // Remove completed/cancelled/no-show entries from the list
        entryElement.remove()
        console.log('[BusinessQueueController] Removed entry:', data.entry_id)
      } else {
        // Update existing entry in place (e.g. waiting -> called -> serving)
        entryElement.outerHTML = entryHtml
        console.log('[BusinessQueueController] Updated entry:', data.entry_id)
      }
    } else if (data.status === 'waiting' && entryHtml) {
      // New entry — insert into the waiting list
      this.insertNewEntry({ ...data, html: entryHtml })
    }

    // Update queue status section (e.g. on business show page)
    if (data.queue_status_html) {
      const statusElement = document.querySelector('[data-queue-status]')
      if (statusElement) {
        statusElement.innerHTML = data.queue_status_html
      }
    }

    // Always update stats and waiting count badge
    this.updateStats(data)
    this.toggleEmptyMessage()
  }

  insertNewEntry(data) {
    const waitingContainer = document.getElementById('waiting-entries')
    if (waitingContainer) {
      waitingContainer.insertAdjacentHTML('beforeend', data.html)
      console.log('[BusinessQueueController] Inserted new entry:', data.entry_id)
    }
  }

  handleEntryRemoval(data) {
    const entryElement = document.querySelector(`[data-queue-entry-id="${data.entry_id}"]`)
    if (entryElement) {
      entryElement.remove()
      console.log('[BusinessQueueController] Removed transferred entry:', data.entry_id)
    }
    if (data.queue_status_html) {
      const statusElement = document.querySelector('[data-queue-status]')
      if (statusElement) statusElement.innerHTML = data.queue_status_html
    }
    this.updateStats(data)
    this.toggleEmptyMessage()
  }

  updateStats(data) {
    // Update dashboard stat cards
    const statWaiting = document.getElementById('stat-waiting')
    if (statWaiting && data.waiting_count !== undefined) {
      statWaiting.textContent = data.waiting_count
    }

    const statServed = document.getElementById('stat-served')
    if (statServed && data.total_served !== undefined) {
      statServed.textContent = data.total_served
    }

    const statAvgWait = document.getElementById('stat-avg-wait')
    if (statAvgWait && data.avg_wait !== undefined) {
      statAvgWait.textContent = `~${data.avg_wait}`
    }

    // Update waiting count badge on queue cards
    const waitingBadge = document.querySelector(`[data-queue-waiting-count="${this.businessQueueIdValue}"]`)
    if (waitingBadge && data.waiting_count !== undefined) {
      waitingBadge.textContent = `${data.waiting_count} waiting`
    }
  }

  toggleEmptyMessage() {
    const waitingContainer = document.getElementById('waiting-entries')
    const emptyMessage = document.getElementById('waiting-empty-message')
    if (!waitingContainer || !emptyMessage) return

    const hasEntries = waitingContainer.querySelectorAll('[data-queue-entry-id]').length > 0
    emptyMessage.classList.toggle('hidden', hasEntries)
  }

  updateQueueStatus(data) {
    const statusElement = document.querySelector('[data-queue-status]')
    if (statusElement && data.html) {
      statusElement.innerHTML = data.html
    }
  }
}
